import React, { FC } from 'react';
import styles from './login_form.module.scss';

type Props = {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

export const LoginForm: FC<Props> = ({ children, onSubmit }) => (
  <form className={styles.form} onSubmit={onSubmit}>
    {children}
  </form>
);
